import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

export type SortDirection = 'asc' | 'desc';

@Pipe({ name: 'sortBy' })
export class SortByPipe implements PipeTransform {
  transform<T>(values: T[], order: SortDirection, column: keyof T = null): T[] {
    if (!values || order === null || !order) {
      return values;
    }

    if (values.length <= 1) {
      return values;
    }

    if (!column || (typeof column === 'string' && column === '')) {
      values = [...values];
      return order === 'asc' ? values.sort() : values.sort().reverse();
    }

    return orderBy<T>(values, [column], [order]);
  }
}
